import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  Typography,
} from "@material-tailwind/react";
import cookieService from "@/features/Cookie/services";
import Link from "next/link";

interface Props {
  isOpen: boolean;
  onClose: (value: boolean) => void;
}

export function CookieModal({ isOpen, onClose }: Props) {
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleOpen = () => {
    onClose(!open);
    setOpen((cur) => !cur);
  };

  const accept = () => {
    cookieService.accept();
    handleOpen();
  };

  const decline = () => {
    cookieService.decline();
    handleOpen();
  };

  return (
    <>
      <Dialog open={open} handler={handleOpen}>
        <DialogBody divider className="grid place-items-center gap-4">
          <img
            src="/image/cookie.png"
            alt="ไอคอนคุกกี้"
            className="w-12 h-12"
          />
          <Typography variant="h5">เราใช้คุกกี้</Typography>
          <Typography className="text-center font-normal">
            เพื่อให้ทุกคนได้ประสบการณ์การใช้งานที่ดียิ่งขึ้น{" "}
            <Link
              href="/cookie-policy"
              onClick={handleOpen}
              className="font-bold text-black"
            >
              นโยบายของเรา
            </Link>
          </Typography>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button
            variant="text"
            color="blue-gray"
            onClick={accept}
            name="reject-cookies"
            aria-label="ปฏิเสูคุกกี้ - ไม่ยอมรับการใช้คุกกี้บนเว็บไซต์"
          >
            ปฏิเสธคุกกี้
          </Button>
          <Button
            onClick={decline}
            className="bg-[#188F46]"
            name="accept-cookies"
            aria-label="ยอมรับคุกกี้ - ยินยอมให้ใช้คุกกี้บนเว็บไซต์"
          >
            ยอมรับคุกกี้
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}
